import { render } from "./GameLetter.vue?vue&type=template&id=125a2e51&scoped=true"
import script from "./GameLetter.vue?vue&type=script&lang=js"
export * from "./GameLetter.vue?vue&type=script&lang=js"

import "./GameLetter.vue?vue&type=style&index=0&id=125a2e51&scoped=true&lang=css"

import exportComponent from "/Users/vaclavsmital/Projects/geoword/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125a2e51"]])

export default __exports__